<template>
  <div class="sticky-top">
    <div class="is-overflowing">
      <div style="border-bottom: solid 1px #222223;">
        <div v-if="$store.getters.currentQuestionnaire.Status != 'Closed' && $store.getters.isCountryRespondent">
          <b-button class="is-primary" :disabled="canApprove" @click="ApproveQuestionnaire">Approve Current Version</b-button>
          <br />
        </div>
        <p >Current Version Approved By:</p>
        <p v-if="approvements.length < 1">n/a</p>
        <div v-for="a in approvements">
          <p class="is-marginless" style="font-size: 14px;">{{ a.Name }} - {{ a.OrganizationName }} - {{ a.Stamp | utc | moment('MM/DD/YYYY') }} UTC</p>
        </div>
        <br />
        <div style="font-size: 14px;" v-if="$store.getters.currentQuestionnaire.Status == 'Closed'">
          <p>Closed On: {{ $store.getters.currentQuestionnaire.ClosedOn | utc | moment('MM/DD/YYYY') }} UTC</p>
        </div>
        <div v-if="$store.getters.currentQuestionnaire.Status != 'Closed' && $store.getters.isCountryRespondent">
          <div v-show="canSubmit">
            <b-button @click="closeQuestionnaire" class="is-primary">Submit As Final</b-button>
          </div>
        </div>
      </div>
      <div>
        <br />
        <b-collapse :open.sync="Intro">
          <a href="javascript://" slot="trigger">
            Intro Questions &nbsp;
            <span v-show="!Intro"><i class="fas fa-angle-down"></i></span>
            <span v-show="Intro"><i class="fas fa-angle-up"></i></span>
          </a>
          <div class="space">
            <ul>
              <li :class="{'is-active':$route.path == '/questionnaire/disclaimer'}">
                <router-link to="/questionnaire/participation">Terms of Participation</router-link>&nbsp;
              </li>
              <li :class="{'is-active':$route.path == '/questionnaire/consent'}">
                <router-link to="/questionnaire/consent">Consent</router-link>&nbsp;
              </li>
            </ul>
          </div>
        </b-collapse>
      </div>
      <div>
        <b-collapse :open.sync="A" aria-id="A_collapse">
          <a href="javascript://" slot="trigger" aria-controls="A_collapse">
            Variable A &nbsp;
            <span v-show="!A"><i class="fas fa-angle-down"></i></span>
            <span v-show="A"><i class="fas fa-angle-up"></i></span>
          </a>
          <div class="space">
            <ul>
              <li :class="{'is-active':$route.path == '/questionnaire/a/0'}">
                <router-link to="/questionnaire/a/0">Summary of National Implementation</router-link>&nbsp;
                <span v-show="IsLocked('/questionnaire/a/0')"><i class="fad fa-user-lock"></i></span>
              </li>
              <li :class="{'is-active':$route.path == '/questionnaire/a/1'}">
                <router-link to="/questionnaire/a/1">IDERA extension</router-link>&nbsp;
                <span v-show="IsLocked('/questionnaire/a/1')"><i class="fad fa-user-lock"></i></span>
              </li>
              <li :class="{'is-active':$route.path == '/questionnaire/a/2'}">
                <router-link to="/questionnaire/a/2">Liens</router-link>&nbsp;
                <span v-show="IsLocked('/questionnaire/a/2')"><i class="fad fa-user-lock"></i></span>
              </li>
              <li :class="{'is-active':$route.path == '/questionnaire/a/3'}">
                <router-link to="/questionnaire/a/3">Detention Rights</router-link>&nbsp;
                <span v-show="IsLocked('/questionnaire/a/3')"><i class="fad fa-user-lock"></i></span>
              </li>
              <li :class="{'is-active':$route.path == '/questionnaire/a/4'}">
                <router-link to="/questionnaire/a/4">Comments</router-link>&nbsp;
                <span v-show="IsLocked('/questionnaire/a/4')"><i class="fad fa-user-lock"></i></span>
              </li>
            </ul>
          </div>
        </b-collapse>
      </div>
      <div>
        <b-collapse :open.sync="B" aria-id="B_collapse">
          <a href="javascript://" slot="trigger" aria-controls="B_collapse">
            Variable B &nbsp;
            <span v-show="!B"><i class="fas fa-angle-down"></i></span>
            <span v-show="B"><i class="fas fa-angle-up"></i></span>
          </a>
          <div class="space">
            <ul>
              <li :class="{'is-active':$route.path == '/questionnaire/b/0'}">
                <router-link to="/questionnaire/b/0">Variable B</router-link>&nbsp;
                <span v-show="IsLocked('/questionnaire/b/0')"><i class="fad fa-user-lock"></i></span>
              </li>
            </ul>
          </div>
        </b-collapse>
      </div>
      <div>
        <b-collapse :open.sync="E" aria-id="E_collapse">
          <a href="javascript://" slot="trigger" aria-controls="E_collapse">
            Variable E &nbsp;
            <span v-show="!E"><i class="fas fa-angle-down"></i></span>
            <span v-show="E"><i class="fas fa-angle-up"></i></span>
          </a>
          <div class="space">
            <ul>
              <li :class="{'is-active':$route.path == '/questionnaire/e/0'}">
                <router-link to="/questionnaire/e/0">Indicators relating to legal protectionism (choice of foreign law)</router-link>&nbsp;
                <span v-show="IsLocked('/questionnaire/e/0')"><i class="fad fa-user-lock"></i></span>
              </li>
              <li :class="{'is-active':$route.path == '/questionnaire/e/1'}">
                <router-link to="/questionnaire/e/1">Indicators relating to legal protectionism (choice of foreign jurisdiction)</router-link>&nbsp;
                <span v-show="IsLocked('/questionnaire/e/1')"><i class="fad fa-user-lock"></i></span>
              </li>
              <li :class="{'is-active':$route.path == '/questionnaire/e/2'}">
                <router-link to="/questionnaire/e/2">Indicators relating to legal protectionism (enforcement of foreign judgements)</router-link>&nbsp;
                <span v-show="IsLocked('/questionnaire/e/2')"><i class="fad fa-user-lock"></i></span>
              </li>
              <li :class="{'is-active':$route.path == '/questionnaire/e/3'}">
                <router-link to="/questionnaire/e/3">Indicators relating to legal protectionism (enforcement of foreign arbitral awards)</router-link>&nbsp;
                <span v-show="IsLocked('/questionnaire/e/3')"><i class="fad fa-user-lock"></i></span>
              </li>
              <li :class="{'is-active':$route.path == '/questionnaire/e/4'}">
                <router-link to="/questionnaire/e/4">Indicators of strict rule-based approach to contract interpretation</router-link>&nbsp;
                <span v-show="IsLocked('/questionnaire/e/4')"><i class="fad fa-user-lock"></i></span>
              </li>
              <li :class="{'is-active':$route.path == '/questionnaire/e/5'}">
                <router-link to="/questionnaire/e/5">Indicators of strict application and enforcement of new commercial laws</router-link>&nbsp;
                <span v-show="IsLocked('/questionnaire/e/5')"><i class="fad fa-user-lock"></i></span>
              </li>
              <li :class="{'is-active':$route.path == '/questionnaire/e/6'}">
                <router-link to="/questionnaire/e/6">Indicators of timely repossession (non-bankruptcy)</router-link>&nbsp;
                <span v-show="IsLocked('/questionnaire/e/6')"><i class="fad fa-user-lock"></i></span>
              </li>
              <li :class="{'is-active':$route.path == '/questionnaire/e/7'}">
                <router-link to="/questionnaire/e/7">Indicators of timely repossession (bankruptcy)</router-link>&nbsp;
                <span v-show="IsLocked('/questionnaire/e/7')"><i class="fad fa-user-lock"></i></span>
              </li>
            </ul>
          </div>
        </b-collapse>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        Intro: false,
        A: false,
        B: false,
        E: false,
        navlocks: {},
        approvements: [],
        canApprove: true,
        canSubmit: false
      }
    },
    computed: {
      collapsingHeaders() {
        if (this.$route.path.indexOf("/a/") > -1) {
          this.A = true;
        }
        else if (this.$route.path.indexOf("/b/") > -1)
          this.B = true;
        else if (this.$route.path.indexOf("/e/") > -1)
          this.E = true;
        else {
          this.Intro = true;
        }

      }
    },
    methods: {
      IsLocked(route) {
        for (var prop in this.navlocks) {
          if (prop == route)
            return true;
        }
        return false;
      },
      RefreshLocks() {
        if (this.$store.getters.currentQuestionnaire && this.$store.getters.currentQuestionnaire.Id > 0) {
          this.$http.get("api/questionnaire/navlocks/" + this.$store.getters.currentQuestionnaire.Id).then(resp => {
            //console.log(resp.data);
            this.navlocks = resp.data;
          });
        }
      },
      ApproveQuestionnaire() {
        this.$http.post("api/finalize", { questionnaireId: this.$store.getters.currentQuestionnaire.Id, userId: this.$store.getters.user.Id })
          .then(async resp => {
            if (resp.data) {
              await this.RefreshNames();
              await this.ReadyForFinalization();
              this.canApprove = true;
            }
          })
      },
      RefreshNames() {
        this.$http.post("api/finalize/approvedNames/" + this.$store.getters.currentQuestionnaire.Id)
          .then(resp => {
            this.approvements = resp.data;
          });
      },
      CanApprove() {
        this.$http.post("api/finalize/canApprove", { questionnaireId: this.$store.getters.currentQuestionnaire.Id, userId: this.$store.getters.user.Id })
          .then(async resp => {
            this.canApprove = !resp.data;
          })
      },
      ReadyForFinalization() {
        this.$http.post("api/finalize/readyForFinalization/" + this.$store.getters.currentQuestionnaire.Id)
          .then(async resp => {
            this.$set(this, "canSubmit", resp.data);
          })
      },
      closeQuestionnaire() {
        this.$http.post("api/finalize/close/" + this.$store.getters.currentQuestionnaire.Id)
          .then(async resp => {
            if (resp.data) {
              this.$buefy.notification.open("Submitted and Closed the Questionnaire.");
              this.$router.push("/manage/questionnaires");
            }
          })
      }
    },
    async created() {
      this.$store.getters.bus.$on("load-section", () => { this.RefreshLocks(); });

      await this.RefreshNames();
      await this.CanApprove();
      await this.ReadyForFinalization();
    },
    mounted() {
      if (this.$route.path.indexOf("/a/") > -1)
        this.A = true;
      else if (this.$route.path.indexOf("/b/") > -1)
        this.B = true;
      else if (this.$route.path.indexOf("/e/") > -1)
        this.E = true;
      else
        this.Intro = true;

      this.RefreshLocks();
    },
  }
</script>
<style>

  #questionnaireLinks {
    background-color: #f9f9f9;
    padding: 28px;
  }

    #questionnaireLinks + div {
      padding: 28px 12px;
    }

    #questionnaireLinks a {
      text-decoration-line: none;
    }

    #questionnaireLinks li {
      padding-bottom: 5px;
    }

      #questionnaireLinks li.is-active > a {
        font-weight: bold;
      }

    #questionnaireLinks ul > li {
      line-height: 1;
      margin-bottom: 10px;
    }

    #questionnaireLinks .is-overflowing {
      max-height: 100vh;
      overflow-y: auto;
    }
</style>
